import { BaseDiv } from "./BaseDom";
import { VideoJsPlayer } from "video.js";
import echarts, { ECharts } from "echarts";
import { IOptions } from "../type";

export default class TimelineRiver extends BaseDiv {
  myChart: ECharts;
  constructor(player: VideoJsPlayer, opts?: IOptions) {
    super(player);
    this.addClass("vjs-timeline-river");
    const domDiv = this.el() as HTMLDivElement;
    const width = opts?.width === undefined ? "100%" : `${opts?.width}px`;
    const height = opts?.height === undefined ? "50px" : `${opts?.height}px`;
    this.setStyle({
      position: "absolute",
      top: "0",
      width: width,
      height: height,
    });
    this.myChart = echarts.init(domDiv);
    this.updateEChartsOptions(opts);
  }

  updateEChartsOptions(opts?: IOptions): void {
    const color = (opts?.color || "rgba(255, 255, 255, 0.3)") as string;
    // const bgColor = (opts?.bgColor || "rgba(0, 0, 0, 0.5)") as string;
    const dataKeys = opts?.data ? Object.keys(opts?.data) : [];
    const dataVals = opts?.data ? Object.values(opts?.data) : [];
    // 指定图表的配置项和数据
    // NOTICE: the grid left and right must be equal to 10
    const option = {
      // backgroundColor: bgColor,
      grid: {
        left: 10,
        right: 10,
        bottom: 0,
        top: 0,
      },
      xAxis: {
        show: false,
        boundaryGap: false,
        data: dataKeys,
      },
      yAxis: {
        show: false,
      },
      series: [
        {
          name: "risk",
          type: "line",
          smooth: 0.6,
          areaStyle: {
            color: color,
          },
          showSymbol: false,
          data: dataVals,
          lineStyle: {
            width: 0,
            color: color,
          },
        },
      ],
    };
    this.myChart.setOption(option);
  }
}
